'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureById = undefined;

var _sagaTools = require('@classpass/saga-tools');

var _dal = require('@classpass/dal');

/* eslint-disable import/prefer-default-export */

var featureById = exports.featureById = (0, _sagaTools.makeEntityScaffold)('SAGA.API.FEATURE_BY_ID', function (client, id, defaultValue) {
  return client.features.get(id).then(function (data) {
    return data && data.enabled;
  }).catch(function (err) {
    // 404s just mean that the feature is disabled
    if (err instanceof _dal.DALNotFoundError) {
      return false;
    }

    if (typeof defaultValue !== 'undefined') {
      return defaultValue;
    }

    throw err;
  });
}, { defaultKey: 1 });